<template>
  <el-form ref="form" :model="user" label-width="85px">
    <el-form-item :label="this.$t('userinfo.userinfo.username')" prop="username" >
      <el-input v-model="user.username" maxlength="30" :disabled="true" />
    </el-form-item> 
	<label class="roleLabel">{{$t('userinfo.userinfo.ownrole')}}</label>
	<el-tag style="margin-right: 5px;" type="warning" v-for="(item,indexj) in info.roles"
		:key="indexj">{{item}}</el-tag>
    
  </el-form>
</template>

<script>

export default {
  props: {
    user: {
      type: Object
    }
  },
  created() {
  	let user = JSON.parse(window.localStorage.getItem("user"));
  	this.info.username = user.username;
	this.getRequest('/tpa-api/admin/getAdminRoles', null).then(resp => {
		if (resp) {
			this.info.roles = resp.result;
		}
	});
  },
  data() {
    return {
		info:{
			username: '',
			roles: {}
		}
      }
  },
  methods: {
    
  }
};
</script>
<style>
	.roleLabel{
		font-size: 14px;
		line-height: 40px;
		margin-right: 8px;
	}
</style>
